import styled from 'styled-components';

import TableUI from '@src/components/ui/Table';

export const Table = styled(TableUI)`
  max-height: 400px;
`;
